<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 sm6 md4>
        <material-card>
          <v-toolbar slot="header" color="primary" class="elevation-4">
            <v-toolbar-title>Your account</v-toolbar-title>
          </v-toolbar>
          <v-form>
            <v-container py-0>
              <v-layout wrap>
                <v-flex xs12 md6>
                  <v-text-field
                    label="First name"
                    class="purple-input"
                    v-model="loggedUser.user_first_name"
                    :readonly="isEditable == false"
                    compact
                  />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    label="Last name"
                    class="purple-input"
                    v-model="loggedUser.user_last_name"
                    :readonly="isEditable == false"
                    compact
                  />
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field
                    label="Email/Username"
                    class="purple-input"
                    v-model="loggedUser.username"
                    :readonly="isEditable == false"
                    compact
                  />
                </v-flex>
                <v-flex xs12 md12>
                  <v-btn color="primary" @click="logout()">Logout</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
      </v-flex>
      <v-flex md4 sm6 lg4 first-row>
        <material-card>
          <v-toolbar slot="header" color="primary" class="elevation-4">
            <v-toolbar-title>Reset Password</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-form ref="userPasswordForm">
          <v-form-base
              v-bind:value="changePasswordForm"
              v-bind:schema="changePasswordSchema"
              :key="dataLoaded"
            />
          </v-form>
           <v-btn
              class="ma-2"
              color="primary"
              dark
              @click.stop="resetPassword()"
            >Submit</v-btn>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import apiService from '@/services'
import VFormBase from 'vuetify-form-base'

const formRules = {
  required: field => v => (v != null && !!v && v.length > 0) || `${field} is required`,
  requiredSelect: field => v => v || `${field} is required`,
  validEmail: v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
}

export default {
  name: 'userpage',
  data: () => ({
    isEditable: false,
    dataLoaded: false,
    changePasswordForm: {
      password: '',
      password_repeat: ''
    }
  }),
  components: {
    VFormBase
  },
  computed: {
    ...mapState({ auth: 'auth', alerts: (state) => state.alert.snackbars }),

    loggedIn () {
      return this.auth.loggedIn
    },
    loggedUser () {
      return this.auth.user || null
    },
    changePasswordSchema () {
      return {
        password: {
          type: 'password',
          label: 'Password',
          clearable: true,
          flex: 6,
          rules: [formRules.required('Password')]
        },
        password_repeat: {
          type: 'password',
          label: 'Confirm Password',
          clearable: true,
          flex: 6,
          rules: [formRules.required('Password'),
            (value) => value === this.changePasswordForm.password || 'The password confirmation does not match.']
        }
      }
    }
  },
  methods: {
    returnData () {
      console.log(this.loggedUser.email)
    },
    resetPassword () {
      this.changePasswordForm.user_id = this.loggedUser.id
      if (this.$refs.userPasswordForm.validate()) {
        apiService
          .resetPassword(this.changePasswordForm)
          .then(response => {
            console.log(response)
            this.$store.dispatch('alert/showSnackbar', {
              color: 'success',
              type: 'success',
              text: 'Password updated succesfully'
            })
          })
          .catch(error => {
            console.log(error)
            this.$store.dispatch('alert/showSnackbar', {
              color: 'error',
              text: 'Error updating password.'
            })
          })
      }
    },
    logout () {
      this.$store.dispatch('auth/logout', this.user).then(() => {
        this.$router.push({ name: 'login' })
      })
    },
    gotologin () {
      this.$router.push({
        name: 'login'
      })
    }
  }
}
</script>
